module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"videoProcessing":"Видео в процессе обработки","processingTip":"Это может занять несколько минут.","processingTip2":"Наберитесь терпения, это того стоит."}}')
  delete Component.options._Ctor
}
